export function getView(value) {
  return value !== 'PRIVATE'
}
